import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from '../Link';
import Caret from '../Caret';
import './SiteNavLink.scss';

class SiteNavLink extends Component {
  static defaultProps = {
    variant: 'default',
    active: false,
    isInternal: false,
    noLeftPadding: false,
    noRightPadding: false
  }

  render() {
    const {
      isInternal,
      variant,
      active,
      respondWidth,
      disabled,
      respondFontSize,
      truncateLongText,
      parentClassName,
      caret,
      href,
      onClick,
      onHover,
      children,
      title,
      isIcon,
      noLeftPadding,
      noRightPadding,
      newEl,
      noLineHeight,
      smallLineHeight,
      uppercase,
      borderLeft,
      truncateTitle,
      alignLeft,
      fullWidth,
      isRtl,
      smallFont
    } = this.props;
    const baseClassName = 'pb-site-nav-link';
    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName,
      [`${baseClassName}--${variant}`]: variant,
      [`${baseClassName}--active`]: active,
      [`${baseClassName}--respond-width`]: respondWidth,
      [`${baseClassName}--respond-font-size`]: respondFontSize,
      [`${baseClassName}--truncate-long-text`]: truncateLongText,
      [`${baseClassName}--caret`]: caret,
      [`${baseClassName}--icon`]: isIcon,
      [`${baseClassName}--no-left-padding`]: noLeftPadding,
      [`${baseClassName}--no-line-height`]: noLineHeight,
      [`${baseClassName}--small-line-height`]: smallLineHeight,
      [`${baseClassName}--no-right-padding`]: noRightPadding,
      [`${baseClassName}--uppercase`]: uppercase,
      [`${baseClassName}--border-left`]: borderLeft,
      [`${baseClassName}--truncate-title`]: truncateTitle,
      [`${baseClassName}--align-left`]: alignLeft,
      [`${baseClassName}--full-width`]: fullWidth,
      [`${baseClassName}--small-font`]: smallFont,
    }

    let caretEl;
    if (caret) {
      caretEl = <Caret direction={caret} parentClassName={`${baseClassName}__caret`}/>
    }

    return (
      <Link
        isInternal={isInternal}
        parentClassName={classNames(classes)}
        disabled={disabled}
        onClick={onClick}
        onHover={onHover}
        title={title}
        newEl={newEl}
        href={href}><span id={this.props.id} className={isRtl ? `${baseClassName}__title ${baseClassName}__title--rtl` : `${baseClassName}__title`}>{children}</span>{caretEl}</Link>
    );
  }
}

SiteNavLink.propTypes = {
  children: PropTypes.node,
  parentClassName: PropTypes.string,
  href: PropTypes.string,
  active: PropTypes.bool,
  truncateLongText: PropTypes.bool,
  disabled: PropTypes.bool,
  respondWidth: PropTypes.bool,
  respondFontSize: PropTypes.bool,
  isInternal: PropTypes.bool,
  onClick: PropTypes.func,
  /* Default size is default */
  variant: PropTypes.oneOf([
    'default',
    'bordered',
    'sublinks',
    'bottom-tabs'
  ]),
  caret: PropTypes.oneOf([
    'down',
    'top',
    'left',
    'right'
  ]),
  title: PropTypes.string,
  isIcon: PropTypes.bool
};

export default SiteNavLink;


// WEBPACK FOOTER //
// ./src/components/SiteNavLink/SiteNavLink.jsx